export const actions = {
  set_state: 'topup_admin/set_state',
  get_list: 'topup_admin/get_list',
  confirm_topup: 'topup_admin/confirm_topup'
}
